// @flow
import type {
  HandicappingStoreOpenModalAction,
  HandicappingStoreCloseModalAction,
  SetHandicappingStoreModalUrlAction
} from "@tvg/shared-actions/HandicappingStore";
import type { PotentialReturnParentPage } from "../reducers/App/modalReducer";

export type termsContentType =
  | "privacy policy"
  | "terms & conditions"
  | "accessibility"
  | "";

export type PromosOpenModalAction = { type: "OPEN_PROMOS_MODAL" };
export type PromosCloseModalAction = { type: "CLOSE_PROMOS_MODAL" };
export type NavigationOpenModalAction = {
  type: "OPEN_NAVIGATION_MODAL",
  payload: string
};

export type GeoComplyErrorModalAction = { type: "GEOCOMPLY_ERROR_MODAL" };

export type NavigationCloseModalAction = {
  type: "CLOSE_NAVIGATION_MODAL",
  payload: string
};
export type BetPreferencesCloseModalAction = {
  type: "CLOSE_BET_PREFERENCES_MODAL"
};

export type BetPreferencesOpenModalAction = {
  type: "OPEN_BET_PREFERENCES_MODAL"
};
export type FeatureTogglesOpenModalAction = {
  type: "OPEN_FEATURE_TOGGLES_MODAL"
};
export type FeatureTogglesCloseModalAction = {
  type: "CLOSE_FEATURE_TOGGLES_MODAL"
};
export type OpenTrackSelectorModalAction = {
  type: "OPEN_TRACK_SELECTOR_MODAL"
};
export type OpenRaceSelectorModalAction = {
  type: "OPEN_RACE_SELECTOR_MODAL"
};
export type OpenHelpModalAction = {
  type: "OPEN_HELP_MODAL"
};
export type CloseHelpModalAction = {
  type: "CLOSE_HELP_MODAL"
};
export type CloseTrackSelectorModalAction = {
  type: "CLOSE_TRACK_SELECTOR_MODAL"
};
export type CloseRaceSelectorModalAction = {
  type: "CLOSE_RACE_SELECTOR_MODAL"
};
export type SupportOpenModalAction = { type: "OPEN_SUPPORT_MODAL" };
export type SupportCloseModalAction = { type: "CLOSE_SUPPORT_MODAL" };

export type WelcomeNewUserOpenModalAction = {
  type: "OPEN_WELCOME_NEW_USER_MODAL"
};
export type WelcomeNewUserCloseModalAction = {
  type: "CLOSE_WELCOME_NEW_USER_MODAL"
};

export type PotencialReturnOpenModalAction = {
  type: "OPEN_POTENCIAL_RETURN_MODAL",
  payload: {
    hasMessage: boolean,
    parentPage: PotentialReturnParentPage
  }
};
export type PotencialReturnCloseModalAction = {
  type: "CLOSE_POTENCIAL_RETURN_MODAL"
};

export type PickBetsHowItWorksOpenModalAction = {
  type: "OPEN_PICK_BETS_HOW_IT_WORKS_MODAL"
};

export type PickBetsHowItWorksCloseModalAction = {
  type: "CLOSE_PICK_BETS_HOW_IT_WORKS_MODAL"
};

export type InvalidResidentialAddressOpenModalAction = {
  type: "OPEN_INVALID_RESIDENTIAL_ADDRESS_MODAL"
};
export type InvalidResidentialAddressCloseModalAction = {
  type: "CLOSE_INVALID_RESIDENTIAL_ADDRESS_MODAL"
};
export type CrossProductNavigationOpenModalAction = {
  type: "OPEN_CROSS_PRODUCT_NAVIGATION_MODAL"
};
export type CrossProductNavigationCloseModalAction = {
  type: "CLOSE_CROSS_PRODUCT_NAVIGATION_MODAL"
};
export type TransactionHistoryOpenModalAction = {
  type: "OPEN_TRANSACTION_HISTORY_MODAL"
};
export type TransactionHistoryCloseModalAction = {
  type: "CLOSE_TRANSACTION_HISTORY_MODAL"
};
export type CloseAllModalAction = {
  type: "CLOSE_ALL_MODALS"
};

export type Actions =
  | PromosOpenModalAction
  | PromosCloseModalAction
  | NavigationOpenModalAction
  | NavigationCloseModalAction
  | BetPreferencesCloseModalAction
  | BetPreferencesOpenModalAction
  | FeatureTogglesOpenModalAction
  | FeatureTogglesCloseModalAction
  | HandicappingStoreOpenModalAction
  | HandicappingStoreCloseModalAction
  | SetHandicappingStoreModalUrlAction
  | OpenTrackSelectorModalAction
  | CloseTrackSelectorModalAction
  | OpenRaceSelectorModalAction
  | CloseRaceSelectorModalAction
  | SupportOpenModalAction
  | SupportCloseModalAction
  | WelcomeNewUserOpenModalAction
  | WelcomeNewUserCloseModalAction
  | CloseAllModalAction
  | OpenHelpModalAction
  | CloseHelpModalAction
  | PotencialReturnOpenModalAction
  | PotencialReturnCloseModalAction
  | PickBetsHowItWorksOpenModalAction
  | PickBetsHowItWorksCloseModalAction
  | InvalidResidentialAddressOpenModalAction
  | InvalidResidentialAddressCloseModalAction
  | CrossProductNavigationOpenModalAction
  | CrossProductNavigationCloseModalAction
  | TransactionHistoryOpenModalAction
  | TransactionHistoryCloseModalAction
  | GeoComplyErrorModalAction;

export const openPromosModal = (): PromosOpenModalAction => ({
  type: "OPEN_PROMOS_MODAL"
});

export const closePromosModal = (): PromosCloseModalAction => ({
  type: "CLOSE_PROMOS_MODAL"
});

export const geoComplyErrorModal = (): GeoComplyErrorModalAction => ({
  type: "GEOCOMPLY_ERROR_MODAL"
});

export const openNavigationModal = (
  contentType: termsContentType
): NavigationOpenModalAction => ({
  type: "OPEN_NAVIGATION_MODAL",
  payload: contentType
});

export const closeNavigationModal = (): NavigationCloseModalAction => ({
  type: "CLOSE_NAVIGATION_MODAL",
  payload: ""
});

export const closeBetPrefsModal = (): BetPreferencesCloseModalAction => ({
  type: "CLOSE_BET_PREFERENCES_MODAL"
});

export const openBetPrefsModal = (): BetPreferencesOpenModalAction => ({
  type: "OPEN_BET_PREFERENCES_MODAL"
});

export const openFeatureTogglesModal = (): FeatureTogglesOpenModalAction => ({
  type: "OPEN_FEATURE_TOGGLES_MODAL"
});

export const closeFeatureTogglesModal = (): FeatureTogglesCloseModalAction => ({
  type: "CLOSE_FEATURE_TOGGLES_MODAL"
});

export const openTrackSelectorModal = (): OpenTrackSelectorModalAction => ({
  type: "OPEN_TRACK_SELECTOR_MODAL"
});

export const openRaceSelectorModal = (): OpenRaceSelectorModalAction => ({
  type: "OPEN_RACE_SELECTOR_MODAL"
});

export const closeTrackSelectorModal = (): CloseTrackSelectorModalAction => ({
  type: "CLOSE_TRACK_SELECTOR_MODAL"
});

export const closeRaceSelectorModal = (): CloseRaceSelectorModalAction => ({
  type: "CLOSE_RACE_SELECTOR_MODAL"
});

export const openHelpModal = (): OpenHelpModalAction => ({
  type: "OPEN_HELP_MODAL"
});

export const closeHelpModal = (): CloseHelpModalAction => ({
  type: "CLOSE_HELP_MODAL"
});

export const openSupportModal = (): SupportOpenModalAction => ({
  type: "OPEN_SUPPORT_MODAL"
});
export const closeSupportModal = (): SupportCloseModalAction => ({
  type: "CLOSE_SUPPORT_MODAL"
});

export const openWelcomeNewUserModal = (): WelcomeNewUserOpenModalAction => ({
  type: "OPEN_WELCOME_NEW_USER_MODAL"
});
export const closeWelcomeNewUserModal = (): WelcomeNewUserCloseModalAction => ({
  type: "CLOSE_WELCOME_NEW_USER_MODAL"
});

export const closeAllModals = (): CloseAllModalAction => ({
  type: "CLOSE_ALL_MODALS"
});

export const openPotencialReturnModal = ({
  hasMessage,
  parentPage
}: {
  hasMessage: boolean,
  parentPage: PotentialReturnParentPage
}): PotencialReturnOpenModalAction => ({
  type: "OPEN_POTENCIAL_RETURN_MODAL",
  payload: { hasMessage, parentPage }
});
export const closePotencialReturnModal =
  (): PotencialReturnCloseModalAction => ({
    type: "CLOSE_POTENCIAL_RETURN_MODAL"
  });

export const openPickBetsHowItWorksModal =
  (): PickBetsHowItWorksOpenModalAction => ({
    type: "OPEN_PICK_BETS_HOW_IT_WORKS_MODAL"
  });

export const closePickBetsHowItWorksModal =
  (): PickBetsHowItWorksCloseModalAction => ({
    type: "CLOSE_PICK_BETS_HOW_IT_WORKS_MODAL"
  });

export const openInvalidResidentialAddressModal =
  (): InvalidResidentialAddressOpenModalAction => ({
    type: "OPEN_INVALID_RESIDENTIAL_ADDRESS_MODAL"
  });

export const closeInvalidResidentialAddressModal =
  (): InvalidResidentialAddressCloseModalAction => ({
    type: "CLOSE_INVALID_RESIDENTIAL_ADDRESS_MODAL"
  });

export const openCrossProductNavigationModal =
  (): CrossProductNavigationOpenModalAction => ({
    type: "OPEN_CROSS_PRODUCT_NAVIGATION_MODAL"
  });

export const closeCrossProductNavigationModal =
  (): CrossProductNavigationCloseModalAction => ({
    type: "CLOSE_CROSS_PRODUCT_NAVIGATION_MODAL"
  });
export const openTransactionHistoryModal =
  (): TransactionHistoryOpenModalAction => ({
    type: "OPEN_TRANSACTION_HISTORY_MODAL"
  });

export const closeTransactionHistoryModal =
  (): TransactionHistoryCloseModalAction => ({
    type: "CLOSE_TRANSACTION_HISTORY_MODAL"
  });
